import React, {useState, useEffect} from 'react';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import PropTypes from 'prop-types';
import {toTime, toTimeType, timeConverter, isObjectEmpty, uploadCSV, replaceAll, timeConverterSM} from '../../../../Utils';
import Spinner from '../../../common/generic/Spinner';

const ContainerComp = ({pageState, reportState, csvData, setcsvData}) =>{
    const {database, deleteThis, request, fetchModules, modulesData, modulesReady } = pageState;
    const [processedMarks, setProcessedMarks] = useState({});
    const [markRecords, setMarkRecords] = useState({});
    const {selectedStudents, selectedProgram} = reportState;

    /*
    CSV NOTES
    =========
    There is a big problem when trying to upload more then 1 csv file.  The below system will reset all the data in 
    this component and start it over when when the user clicks save.
    
    Steps
    1) User clicks save in either ProgramReportTableComp or AcitivityReportComp
        1b) openCSVPage() will populate csvData using setcsvData({processStage:'newRequest'});
    2) ViewReportsPage checks to see if the marks have changed (* seems to be called way to many times...)
        2b) setReportType(csvData.reportType);
            setSelectedProgram({...csvData.selectedProgram});
            setSelectedStudents([...csvData.selectedStudents]); 
    3) Start the report
        3a) CSV Step 1: checks if a new request for csv and starts to clear the data
        3b) CSV Step 2: clears the data 
        3c) CSV Step 3: keep checking to see when the data has been cleared
        3d) CSV Step 4: once the data for this component has been reset then start the normal start up process for this comp.
        3e) (The normal Startup starts at CSV Step 1) 
    */

    // CSV Step 4: once the data for this component has been reset then start the normal start up process for this comp.
    // The normal Startup starts at CSV Step 1 
    const tryLoadingCSVStage2 = () => {
        if(!csvData) return;
        if(csvData.processStage === 'clearingData'){
            if(!database['getMadMinuteFacts'] && isObjectEmpty(markRecords) && isObjectEmpty(processedMarks)){
                setcsvData({...csvData, processStage:'clearedData'});
            }
        }
    };
    // CSV Step 3: keep checking to see when the data has been cleared
    useEffect(() =>{tryLoadingCSVStage2();},[database['getMadMinuteFacts']]);
    useEffect(() =>{tryLoadingCSVStage2();},[markRecords]);
    useEffect(() =>{tryLoadingCSVStage2();},[processedMarks]);

    // CSV Step 2: clears the data
    useEffect(() => {
        if(!csvData) return;

        if(csvData.processStage === 'clearingData'){
            deleteThis('getMadMinuteFacts');
            setMarkRecords({});
            setProcessedMarks({});
        }
    },[csvData]);

    // CSV Step 1: checks if a new request for csv and starts to clear the data 
    // Normal Startup Step 1:
    useEffect(() => {
        if(csvData){
            if(csvData.processStage==='newRequest'){
                // csvData.setloadingCSV({...csvData.loadingCSV, MMMasteredFacts:true});
                setcsvData({...csvData, processStage:'clearingData'});
                return;
            }

            if(csvData.processStage==='clearingData') return;
        }

        if(!isObjectEmpty(markRecords)) return; // already loading

        if(!database['getMadMinuteFacts']){
            let studentQueries = selectedStudents.map(studentRec=>{
                let getMarksQuery={
                    params: studentRec.id+'~'+selectedProgram.id.toLowerCase()+'~FALSE',
                    func:'getMadMinuteFacts'            
                };
                return getMarksQuery;
            });

            if(studentQueries.length > 0){
                let counter = 1;
                studentQueries = studentQueries.map((query,i)=>{
                    let prevQuery = (i!=0) ? studentQueries[i-1] : 'undefinded';
                    if(prevQuery !== 'undefinded'){
                        counter++;
                        query.nextRequest = prevQuery;
                    }
                    return query;
                });
                let loadChainedMarks = studentQueries[studentQueries.length-1];
                loadChainedMarks.numQueries = counter;
                setMarkRecords({info:{numStudents:counter,numLoaded:counter}});

                // pass the link list of saved changes into the database
                request(loadChainedMarks); 
            }
            else
                console.log('Nothing to load?');
        }
    });

    // convert database['getMadMinuteFacts'] into setMarkRecords
    // UDATES - when database['getMadMinuteFacts'] changes
    useEffect(() => {
        if(csvData && csvData.processStage !== 'clearedData') return; // don't setup markRecords for csv files without being ready 
        if(isObjectEmpty(markRecords)) return;
        //(!pageState.isFetchingModules && !modulesReady) && fetchModules(selectedProgram.id.toLowerCase());
        if(!database['getMadMinuteFacts']) return;
        
        let marks = {};
        let key = 'unavailable';
        let counter = {...markRecords.info};

        if(database['getMadMinuteFacts'].isLoaded) counter.numLoaded--;
        
        marks = {
            isloaded: database['getMadMinuteFacts'].isLoaded,
            data: database['getMadMinuteFacts'].data
        }; 
        

        if((marks.data) && !isObjectEmpty(marks.data)){
            key = Object.keys(marks.data)[0].split('+')[0];
        }

        setMarkRecords({...markRecords, info:{...counter}, [key]:marks});

    }, [database['getMadMinuteFacts']]); 

    const tryLoadingNow = () => {
        if(isObjectEmpty(markRecords)) return;
        if(!isObjectEmpty(processedMarks)) return;
        if(markRecords.info.numStudents > 0 && markRecords.info.numLoaded > 0) return;

        let reportData = JSON.parse(localStorage.getItem('reportData'));
        let masterLevel = parseInt(reportData.masterLevel)/100;

        //if(modulesReady) { 
        let studentMarks = selectedStudents.reduce((acc,studentRec)=>{
            let studentID = studentRec.id;
            let studentMarkRecords = markRecords[studentID];
            if(!studentMarkRecords) return acc; // still loading marks

            let marks = studentMarkRecords.data[`${studentID}+${selectedProgram.id.toLowerCase()}+FALSE`];

            acc[`${studentRec.id}+${studentRec.name}`] = marks;
            return acc;
        },{});
        setProcessedMarks(studentMarks);

        if(csvData){
            let newLine = '%0A';
            let csvString = '';
            csvString +=`"Student without marks will not appear in this report"${newLine}`;

            Object.keys(studentMarks).forEach((key) => { 
                let headerStr = `${newLine}"${key.split('+')[1]}"${newLine}"${selectedProgram.name}"${newLine}"Mastered Facts Report"${newLine}`;
                headerStr += '"M = Mastered","L = Learning","N = New"';
                let tableData  = studentMarks[key];
                if(!tableData) return;
                csvString += headerStr;

                if(tableData.AddFacts){
                    csvString += newLine+'"Addition"';
                    let addFacts = tableData.AddFacts.split('');
                    for(let y=0; y< 11; y++){
                        csvString += `${newLine}`;
                        for(let x=0; x< 11; x++){                        
                            csvString += `"${x} + ${y} = ${addFacts[(y*11)+x]}",`;
                        }
                    }
                }

                if(tableData.SubFacts){
                    csvString += newLine+'"Subtraction';
                    let subFacts = tableData.SubFacts.split('');
                    for(let y=0; y< 11; y++){
                        csvString += `${newLine}`;
                        for(let x=0; x< 11; x++){                        
                            csvString += `"${(x+y)} - ${y} = ${subFacts[(y*11)+x]}",`;
                        }
                    }
                }

                if(tableData.MultFacts){
                    csvString += newLine+'"Multiplication"';
                    let multFacts = tableData.MultFacts.split('');
                    for(let y=0; y< 11; y++){
                        csvString += `${newLine}`;
                        for(let x=0; x< 11; x++){                        
                            csvString += `"${x} x ${y} = ${multFacts[(y*11)+x]}",`;
                        }
                    }
                }

                if(tableData.DivFacts){
                    csvString += newLine+'"Division"';
                    let divFacts = tableData.DivFacts.split('');
                    for(let y=0; y< 10; y++){
                        csvString += `${newLine}`;
                        for(let x=0; x< 11; x++){                        
                            csvString += `"${(y+1)*x} / ${(y+1)} = ${divFacts[(y*11)+x]}",`;
                        }
                    }
                }
            });
            
            let name = '';
            if(Object.keys(studentMarks).length===0){
                window.alert('There are no marks for the student(s) selected');
                csvData.setloadingCSV({...csvData.loadingCSV, MMMasteredFacts:false});
                return;
            }

            if(Object.keys(studentMarks).length===1)
                name = Object.keys(studentMarks)[0].split('+')[1]+'_';

            let today = new Date();
            today = timeConverterSM(today.getTime());

            uploadCSV(name+'MadMinuteMasteredReport_'+selectedProgram.name+'_'+today,csvString);
            csvData.setloadingCSV({...csvData.loadingCSV, MMMasteredFacts:false});
        }
        //};
    }; 
    //useEffect(() =>{tryLoadingNow();},[modulesData]);
    useEffect(() =>{tryLoadingNow();},[markRecords]);

    if(csvData) return <></>;
    if(isObjectEmpty(markRecords)) return <> <Spinner/> <center>Loading... ({database['queryCount']}) </center> </>;
    if(markRecords.info.numStudents > 0 && markRecords.info.numLoaded > 0) return <> <Spinner/> <center>Loading... ({database['queryCount']}) </center> </>;

    return <>
        {Object.keys(processedMarks).length < selectedStudents.length && <center> <p>  Students without marks will not appear in this report </p></center>}
        {Object.keys(processedMarks).map((key, i) => (
            <span key={i}><br/> 
            <MasteredFactsComp header={{student: key.split('+')[1], program: selectedProgram.name}} tableData={processedMarks[key]}/>            
            <br/></span>
        ))}
    </>;
};

const MasteredFactsComp = ({header, tableData}) => {
    const [masterLevel, setMasterLevel] = useState(0.8);

    useEffect(()=>{
        let reportData = JSON.parse(localStorage.getItem('reportData'));
        if(masterLevel !== (parseInt(reportData.masterLevel)/100))
            setMasterLevel(parseInt(reportData.masterLevel)/100);
    });

    const headerComp = <center>
        <h4><Row>
            <Col xs='4'>{header.student}</Col> 
            <Col xs='4'>{header.program} </Col>
            <Col xs='4'>Mastered Facts Report</Col>
        </Row></h4>
    </center>;

    const Footer = ()=> <center><hr/></center>;

    return (
        <>
            {headerComp}
            <hr/>
            {!tableData && <>No Marks</>}
            {tableData && <>
                <Row>
                    <Col  xs={6}></Col>
                    <Col  className={'text-right'}  xs={2} style={{textAlign:'center', margin: '1px'}}><h6>Color Key:</h6></Col>
                    <Col  xs={1} style={{textAlign:'center', margin: '1px', border: '1px solid black'}}>New</Col>
                    <Col  xs={1} style={{textAlign:'center', margin: '1px', background:'yellow'}}>Learning</Col>
                    <Col  xs={1} style={{textAlign:'center', margin: '1px', background:'lightgreen'}}>Mastered</Col>
                </Row>

                {(tableData.AddFacts) && <ShowTable type={'ADD'} name={'Addition'} data={tableData.AddFacts.split('')}/>}
                {(tableData.SubFacts) && <ShowTable type={'SUB'} name={'Subtraction'} data={tableData.SubFacts.split('')}/>}
                {(tableData.MultFacts) && <ShowTable type={'MULT'} name={'Multiplication'} data={tableData.MultFacts.split('')}/>}
                {(tableData.DivFacts) && <ShowTable type={'DIV'} name={'Division'} data={tableData.DivFacts.split('')}/>}

                <Footer/>
            </>}
        </>
    );
};
MasteredFactsComp.propTypes = {
    tableData: PropTypes.object
};

const ShowTable = ({type, data, name}) =>{
    const [matrix, setMatrix] = useState([]);

    const headerComp = 
        <h4><Row>
            <Col xs='12'>{name}</Col> 
        </Row></h4>;

    useEffect(()=>{
        if(matrix.length!==0) return;

        let m = [];
        if(name === 'Addition'){
            for(let y=0; y< 11; y++){
                for(let x=0; x< 11; x++){
                    if(x===0) m[y] = [];
                    m[y][x] = {
                        fact: `${x} + ${y}`,
                        status: data[(y*11)+x]
                    };
                }
            }
        }

        if(name === 'Subtraction'){
            for(let y=0; y< 11; y++){
                for(let x=0; x< 11; x++){
                    if(x===0) m[y] = [];
                    m[y][x] = {
                        fact: `${(x+y)} - ${y}`,
                        status: data[(y*11)+x]
                    };
                }
            }
        }

        if(name === 'Multiplication'){
            for(let y=0; y< 11; y++){
                for(let x=0; x< 11; x++){
                    if(x===0) m[y] = [];
                    m[y][x] = {
                        fact: `${x} x ${y}`,
                        status: data[(y*11)+x]
                    };
                }
            }
        }        

        if(name === 'Division'){
            for(let y=0; y< 10; y++){
                for(let x=0; x< 11; x++){
                    if(x===0) m[y] = [];
                    m[y][x] = {
                        fact: `${(y+1)*x} / ${(y+1)}`,
                        status: data[(y*11)+x]
                    };
                }
            }
        }        


        setMatrix(m);
    });

    return (<>
        {headerComp}
        {matrix.map((rowData,key)=>
            <DrawRow data={rowData} key={key} />
        )}
    </>);
};

const DrawRow = ({data}) =>
    <Row>
        {data.map((cellData,key)=>
            <Col key={key} xs={1} style={{textAlign:'center', margin: '1px', background:(cellData.status==='M'?'lightgreen':cellData.status==='L'?'yellow':'white')}}>{cellData.fact}</Col>
        )}
        <Col xs={1}></Col>
    </Row>;

export default ContainerComp;